module.exports = __webpack_public_path__ + "static/media/makeover_brand_banner_21.b548c141.jpg";